const INVALID_CONTROL_SELECTOR = [
  '[aria-invalid="true"]',
  'input.ng-invalid:not([disabled])',
  'textarea.ng-invalid:not([disabled])',
  'select.ng-invalid:not([disabled])',
].join(', ');

/**
 * Moves keyboard focus to the first invalid control in document order.
 * Error summaries remain visible for grouped announcements; focus lands on the field to correct.
 */
export function focusFirstValidationError(root: HTMLElement): void {
  const invalidControl = root.querySelector(INVALID_CONTROL_SELECTOR);

  if (invalidControl instanceof HTMLElement) {
    focusElement(invalidControl);
    return;
  }

  const errorSummary = root.querySelector('.form-error-summary');

  if (errorSummary instanceof HTMLElement) {
    focusElement(errorSummary);
  }
}

function focusElement(element: HTMLElement): void {
  if (!element.hasAttribute('tabindex')) {
    element.setAttribute('tabindex', '-1');
  }

  element.focus();
}
